document.addEventListener('DOMContentLoaded', () => {
  // Disable the Add to Cart button on page load if no variant is selected and show message
  document.querySelectorAll('form.product-single__form').forEach((node) => {
    const closestAncestor = document.querySelector('.product-single__meta');

    if (document.querySelectorAll('.variant-input').length > 0 && closestAncestor) {
      const elements = closestAncestor.querySelectorAll('.variant-input-wrap .variant-input');
      let variantSelected = false;

      // Check if any variant is already selected (has the "active" class)
      for (let i = 0; i < elements.length; i++) {
        if (elements[i].classList.contains('active')) {
          variantSelected = true;
        }
      }

      // Disable the Add to Cart button initially if no variant is selected
      const submitButton = closestAncestor.querySelectorAll('.payment-buttons button[type=submit]')[0];
      const otherPaymentButton = closestAncestor.querySelectorAll('.payment-buttons .shopify-payment-button__more-options')[0];

      if (!variantSelected) {
        // Disable buttons
        submitButton.setAttribute('disabled', 'disabled');

        if (otherPaymentButton){
          otherPaymentButton.setAttribute('disabled', 'disabled');
        }
        
        // Display the "Please select size option" message if it doesn't exist already
        if (closestAncestor.querySelectorAll('.variant-input-wrap')[0]?.querySelectorAll('.color-red').length === 0) {
          const warningMessage = document.createElement('p');
          warningMessage.classList.add('color-red');
          warningMessage.textContent = 'Please select size option.';
          closestAncestor.querySelectorAll('.variant-input-wrap')[0]?.appendChild(warningMessage);
        }
      }

      // Add the submit event listener to the form
      node.addEventListener('submit', (e) => {
        e.preventDefault();
        console.log('Checking variant selection and Smart Cart readiness');

        // Check if Rebuy Smart Cart is enabled and ready after DOM is loaded
        const isSmartCartReady = window.Rebuy?.SmartCart && window.Rebuy.SmartCart.status === 'ready';

        if (closestAncestor && closestAncestor.querySelector('.variant-input')) {
          let variantSelected = false;
          const elements = closestAncestor.querySelectorAll('.variant-input-wrap .variant-input');

          // Check if any variant input has the "active" class (indicating selection)
          for (let i = 0; i < elements.length; i++) {
            if (elements[i].classList.contains('active')) {
              variantSelected = true;
            }
          }

          if (variantSelected) {
            // Variant is selected, enable the buttons
            submitButton.removeAttribute('disabled');
            otherPaymentButton.removeAttribute('disabled');

            // Check if Smart Cart is ready and enabled, submit the form or open Smart Cart
            if (isSmartCartReady) {
              console.log('Opening Rebuy Smart Cart...');
            } else {
              e.target.submit();  // Proceed to add product to the cart if Smart Cart is not ready
            }
          } else {
            // No variant selected, disable the buttons and show the warning
            submitButton.setAttribute('disabled', 'disabled');
            otherPaymentButton.setAttribute('disabled', 'disabled');
            
            // Display "Please select size option" warning if not already shown
            if (closestAncestor.querySelectorAll('.variant-input-wrap')[0]?.querySelectorAll('.color-red').length === 0) {
              const warningMessage = document.createElement('p');
              warningMessage.classList.add('color-red');
              warningMessage.textContent = 'Please select size option.';
              closestAncestor.querySelectorAll('.variant-input-wrap')[0]?.appendChild(warningMessage);
            }
          }
        } else {
          // No variant input found, proceed with the form submission
          e.target.submit();
        }
      });
    }
  });
});